import { FetchState } from "@/shared/types";
import { CardProviderOptionsState } from "@/employer/types";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";
import { getCardProviderOptions } from "@/shared/api/cardService";

export const initialState: CardProviderOptionsState = {
  fetchState: FetchState.Uninitialized,
  username: "",
  cardProviderOptions: null
};

export const useCardProviderOptionsStore = defineStore("cardProviderOptions", {
  state: (): CardProviderOptionsState => (_.cloneDeep(initialState)),
  getters: {
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isLoading: state => state.fetchState === FetchState.Loading,
    isFailed: state => state.fetchState === FetchState.Failed
  },
  actions: {
    loadCardProviderOptions (args: { username: string, partnerId: number }) {
      if (this.username === args.username) {
        return;
      }

      this.cardProviderOptions = null;
      this.fetchState = FetchState.Loading;

      getCardProviderOptions(args)
        .then(response => {
          this.username = args.username;
          this.fetchState = FetchState.Loaded;
          this.cardProviderOptions = {
            cardProvider: response.data.cardProvider,
            capability: response.data.capability
          };
        })
        .catch(error => {
          this.cardProviderOptions = null;
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
